export const containsNonAsciiCharacters = (str: string): boolean => {
  return /[^\x20-\x7E]/.test(str);
};
